import React from "react"
import PropTypes from "prop-types"
import PatientListItem from "../PatientListItem"
import { withRouter } from '../../lib/withRouter'
import { toggle, setAll } from "../../redux/selection"
import { showSelectedOnly } from "../../redux/settings"
import { setParam, fetch } from "../../redux/query"
import store from "../../redux"
import { connect } from "react-redux"
import Footer from "../Footer"
import Header from "../Header"
import ErrorMessage from "../ErrorMessage"
import Alert from "../Alert"
import "./FhirSearch.less"
import AgeSelector from "../AgeSelector"
import FhirSearchHeader from "../FhirSearchHeader"
import ReactJson from "react-json-view"
import Header2 from "../Header2"


export class FhirSearch extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            searchResults: null, // Store search results here
            loading: false,      // Track search loading state
            error: null,         // Capture errors
        };
    }

    /** Callback to receive data from child component */
    handleSearchResults = (results, isLoading, error = null) => {
        this.setState({
            searchResults: results,
            loading: isLoading,
            error,
        });
    };

    render() {
        console.log("FhirSearch props 1", this.props);

        if (
            this.props.location.search === "?_tab=demographics" ||
            this.props.location.search === "?_tab=conditions" ||
            this.props.location.search === "?_tab=tags"
        ) {
            console.log("Navigating to:", `/patient-list${this.props.location.search}`);
            this.props.router.navigate(`/patient-list${this.props.location.search}`);
            return null;
        }


        return (
            <div className="page">
                <div className="app-header">
                    <Header2
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                        onSearchResults={this.handleSearchResults} // <-- Added
                    />
                    <FhirSearchHeader
                        query={this.props.query}
                        settings={this.props.settings}
                        location={this.props.location}
                        urlParams={this.props.urlParams}
                        onSearchResults={this.handleSearchResults} // <-- Added
                    />
                </div>

                <div className="patient-search-results">
                    {this.renderContents()}
                </div>
            </div>
        )
    }

    renderContents() {
        const { searchResults, loading, error } = this.state;

        // Show spinner while loading
        if (loading) {
            return (
                <div className="patient-search-loading">
                    <i className="fa fa-spinner fa-spin" style={{ fontSize: "20px", marginRight: "10px" }} />
                    Searching... Please wait
                </div>
            );
        }

        // Show error message
        // if (error) {
        //     return <ErrorMessage error={error} />;
        // }

        // Initial state before search
        if (!searchResults) {
            return (
                <Alert>
                    No data fetched yet. Please search for patients.
                </Alert>
            );
        }

        // Show JSON results
        return (
            <div style={{ marginTop: "20px" }}>
                <h4>Search Results (JSON):</h4>
                <ReactJson
                    src={searchResults}
                    name={false}
                    collapsed={false}
                    displayDataTypes={false}
                />
            </div>
        );
    }
}

export default connect(state => state)(withRouter(FhirSearch));
